// extracted by mini-css-extract-plugin
module.exports = {"Arrow":"_2HD-jdIFvh73wz3-H1wpIk","ArrowRight":"_3ONLArCZMx8GQpADcxP29z","Right":"_1Nr-Q1Sbf_6KqXNt8GsN1C","ArrowRightLines":"_2pKSd5IaR2wOzpnTn8VJcl"};